import React, { useState } from "react";
import "./TableSort.scss";

// Components
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type SortDirection = "asc" | "desc" | null;

const TableSort: React.FC<{ by: string; onSort?: (by: string, direction: SortDirection) => void }> = ({ onSort, by }) => {
  const [direction, setDirection] = useState<"asc" | "desc" | null>(null);

  function handleClick() {
    let newDirection: SortDirection = null;

    if (direction === null) newDirection = "asc";
    if (direction === "asc") newDirection = "desc";
    if (direction === "desc") newDirection = null;

    // Set the internal direction and pass to parent component via onSort
    setDirection(newDirection);
    onSort?.(by, newDirection);
  }

  return (
    <span className={`table-sort ${direction === "asc" ? "table-sort--up" : direction === "desc" ? "table-sort--down" : ""}`} data-field={by}>
      <FontAwesomeIcon className="table-sort__icon table-sort__icon--up" icon={["fas", "sort-up"]} onClick={handleClick} />
      <FontAwesomeIcon className="table-sort__icon table-sort__icon--down" icon={["fas", "sort-down"]} onClick={handleClick} />
    </span>
  );
};

export default TableSort;
